import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import configureStore from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import { isMobile } from './extensions/design';
import { OfflineGate } from './components/offline-gate/offline-gate';

const { store, persistor } = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root'));

isMobile && document.documentElement.setAttribute('mobile', '');

root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider locale={ru_RU} theme={{
          token: {
            fontFamily: 'Comfortaa',
            colorPrimary: '#2f6f00',         
            colorPrimaryHover: '#2f6f00',    
            colorPrimaryActive: '#2f6f00',   
          },
          components: {
            Form: {
              marginLG: 8,
              controlHeight: 28,
              labelHeight: 28,
              fontSize: isMobile ? 12 : 14,
              labelColonMarginInlineEnd: 0,
              verticalLabelPadding: isMobile ? 0 : "0 0 8px",
            },
            Input : {
              fontSize: isMobile ? 12 : 14,
            },
            Table: {
              rowSelectedBg: "#eff2ee",
              headerBg: "#fff",
              selectionColumnWidth: 16,
              rowExpandedBg: "#eff2ee",
              fontSize: isMobile ? 12 : 14,
              cellPaddingBlockSM: 2,
            },
            Button: {
              defaultBg: "#ffffff",
              defaultColor: "#2f6f00",
              defaultHoverBg: "#2f6f00",
              defaultHoverColor: "#ffffff"
              // defaultBg: "#2f6f00",
              // defaultColor: "#ffffff",
            },
            Radio: {
              buttonBg: "#ffffff",
              buttonColor: "#2f6f00",
              buttonSolidCheckedBg: "#2f6f00",
              buttonSolidCheckedHoverBg: "#2f6f00",
            },
            Tabs: {
              horizontalItemPaddingSM: 0,
              horizontalItemPaddingLG: 0,
            },
             Tooltip: {
              // colorBgSpotlight: '#eff2ee',
              // colorTextLightSolid: 'green',
              borderRadius: 4,
              boxShadowSecondary: 'none',
              fontSize: 13,
            },
          }
        }}
        >
    <OfflineGate>
      <App />
    </OfflineGate>
    </ConfigProvider>
      </PersistGate>
    </Provider>
);

//#eff2ee